import React, {Component} from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import classNames from 'classnames';

class Select extends Component {
	state = {
		error: null
	};

	constructor(props) {
		super(props);

		this.select = React.createRef();
	}

	componentDidMount() {
		const {handleError, name} = this.props;

		if (handleError) {
			const error = !this.select.current.checkValidity();
			handleError(name, error);
		}
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.refreshError && this.props.refreshError && this.props.handleError) {
			const error = !this.select.current.checkValidity();

			this.setState({
				error
			});

			this.props.handleError(this.props.name, error);
		}

		if (prevProps.value !== this.props.value && this.props.handleError) {
			if (this.props.value) {
				const error = !this.select.current.checkValidity();

				this.setState({
					error
				});

				this.props.handleError(this.props.name, error);
			} else {
				this.setState({
					error: null
				});
			}
		}
	}

	handleChange = (e) => {
		const {handleChange, handleError, name} = this.props;
		const {value} = e.target;

		handleChange(name, value);

		const error = !e.target.checkValidity();

		if (handleError) {
			this.setState({
				error
			});

			handleError(name, error);
		}
	}

	render() {
		const {
			options,
			multiple,
			id: propId,
			name,
			value,
			required,
			inlineLabel,
			label
		} = this.props;

		const id = propId || shortid.generate();

		const {error} = this.state;

		const divClass = classNames('form-control', {'inline-label': inlineLabel, error: error === true, validated: error === false});

		return (
			<div className={divClass}>
				<div>
					{
						label && (
							<label htmlFor={id}>{label}</label>
						)
					}
					<select
						ref={this.select}
						id={id}
						name={name}
						onChange={this.handleChange}
						required={required}
						multiple={multiple}
						value={value}
					>
						{
							options.map((o) => (
								<option key={o.value} value={o.value}>{o.label}</option>
							))
						}
					</select>
				</div>
			</div>
		);
	}
}

Select.propTypes = {
	options: PropTypes.array.isRequired,
	multiple: PropTypes.bool,
	id: PropTypes.string,
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	required: PropTypes.bool,
	label: PropTypes.string,
	inlineLabel: PropTypes.bool,
	handleChange: PropTypes.func.isRequired,
	handleError: PropTypes.func,
	refreshError: PropTypes.bool
};

Select.defaultProps = {
	multiple: false,
	id: null,
	label: 'label',
	inlineLabel: false,
	required: false,
	handleError: null,
	refreshError: false
};

export default Select;
